import Phone from '../Components/Assets/images/fridge.png';
import Tracking from '../Components/Assets/icons/tracking.js';
import Poop from '../Components/Assets/icons/poop.js';
import Photo from '../Components/Assets/icons/photo.js';
import Cart from '../Components/Assets/icons/cart.js';
import Notes from '../Components/Assets/icons/notes.js';
import Notifications from '../Components/Assets/icons/notifications.js';

export const generalfeatures = 
  {
    title: 'Waste less food',
    featureimage: Phone,
    features: [
        {
            icon: Photo, 
            title: 'Quickly add things to your fridge, pantry, freezer, and shopping list by scanning them with your camera '
        },
        {
            icon: Notifications, 
            title: 'Notifications when something is going or has gone out of date'
        },
        {
            icon: Cart, 
            title: 'Stop wondering what you need when you’re at the shop with the simple shopping list'
        },
    ]
  }



// WEBPACK FOOTER //
// ./src/Data/generalfeatures.js